(function () {
  // ------- Helpers -------

  // ------- Qty queue (per line item) -------
var __qtyDesired = new Map();   // key -> number
var __qtyInFlight = new Map();  // key -> boolean

function queueQtyChange(key, qty) {
  if (!key) return;
  __qtyDesired.set(key, qty);

  if (__qtyInFlight.get(key)) return; // redan pågående request för denna key

  __qtyInFlight.set(key, true);

  (async function run() {
    try {
      while (true) {
        var desired = __qtyDesired.get(key);
        if (typeof desired !== 'number') break;

        // När vi skickar den här qty:n: markera att vi "konsumerat" den
        __qtyDesired.delete(key);

        await changeQuantityByKey(key, desired); // din befintliga funktion
        // Om user klickade igen medan requesten pågick:
        // loopen fortsätter och skickar senaste värdet
        if (!__qtyDesired.has(key)) break;
      }
    } finally {
      __qtyInFlight.delete(key);
    }
  })();
}

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getDrawerEl() {
    return qs('cart-drawer.drawer');
  }
  function isOpen() {
    var el = getDrawerEl();
    return !!(el && el.classList.contains('open'));
  }

  function getSectionId() {
    var el = getDrawerEl();
    return el ? el.getAttribute('data-section-id') : null;
  }

  function openBackdrop(open) {
    var bd = qs('.cart-backdrop');
    if (!bd) return;
    bd.classList.toggle('is-open', !!open);

    document.documentElement.classList.toggle('no-scroll', !!open);
    document.body.classList.toggle('no-scroll', !!open);
  }

  function toggleDrawer(open) {
    var el = getDrawerEl();
    if (!el) return;

    var shouldOpen = (typeof open === 'boolean') ? open : !isOpen();
    el.classList.toggle('open', shouldOpen);
    el.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    openBackdrop(shouldOpen);
  }

  // ------- Cart API helpers -------

  function refreshCartSection(keepOpen) {
    if (keepOpen === void 0) keepOpen = true;

    var secId = getSectionId();
    if (!secId) return;

    var url = window.location.pathname + '?sections=' + encodeURIComponent(secId);

    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Section fetch failed');
        return res.json();
      })
      .then(function (json) {
        var html = json[secId];
        if (!html) return;

        var container = document.getElementById('shopify-section-' + secId);
        if (!container) return;

        container.innerHTML = html;

        if (keepOpen) {
          var drawer = getDrawerEl();
          if (drawer) {
            drawer.classList.add('open');
            drawer.setAttribute('aria-hidden', 'false');
            openBackdrop(true);
          }
        }
      })
      .catch(function (err) {
        console.error('refreshCartSection error', err);
      });
  }

  function changeQuantityByKey(key, qty) {
    if (!key) return;

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: qty }),
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('change.js failed');
        return res.json();
      })
      .then(function () {
        return refreshCartSection(isOpen());
      })
      .catch(function (err) {
        console.error('changeQuantityByKey error', err);
      });
  }

  function removeByKey(key) {
    return changeQuantityByKey(key, 0);
  }

  // ------- Event handlers -------

  function onClick(e) {
    var t = e.target;

    // Öppna via trigger
    if (t.closest && t.closest('[data-open="new-cart"]')) {
      e.preventDefault();
      toggleDrawer(true);
      return;
    }

    // Stäng via trigger / X / data-toggle-cart
    if (t.closest && t.closest('[data-close="new-cart"], .close-btn, [data-toggle-cart]')) {
      e.preventDefault();
      toggleDrawer(!isOpen());
      return;
    }

    // Klick på backdrop
    if (t.classList && t.classList.contains('cart-backdrop')) {
      e.preventDefault();
      toggleDrawer(false);
      return;
    }

    // Remove-knapp
    var removeBtn = t.closest && t.closest('[data-toggle-cart-remove], .js-remove-item');
    if (removeBtn) {
      e.preventDefault();
      var key = removeBtn.getAttribute('data-key');
      var href = removeBtn.getAttribute('data-href');
      if (key) {
        removeByKey(key);
        return;
      }
      if (href) {
        window.location.href = href;
        return;
      }
    }

    // Qty plus/minus inne i drawer
    var plus = t.closest && t.closest('[data-qty-plus]');
    var minus = t.closest && t.closest('[data-qty-minus]');
    if (plus || minus) {
      e.preventDefault();

      var row = t.closest('[id^="line-item-"][data-key]');
      if (!row) return;

      var input = row.querySelector('input[type="number"]');
      if (!input) return;

      var key2 = row.getAttribute('data-key');
      if (!key2) return;

      var current = parseInt(input.value || '0', 10) || 0;
      var next = current + (plus ? 1 : -1);
      if (next < 0) next = 0;
      if (next === current) return;

      input.value = String(next);
      queueQtyChange(key2, next);
      return;
    }
  }

  function onInputChange(e) {
    var input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== 'number') return;
    if (!input.closest('#cart-drawer-form')) return;

    var row = input.closest('[id^="line-item-"][data-key]');
    if (!row) return;
    var key = row.getAttribute('data-key');
    if (!key) return;

    var next = parseInt(input.value || '0', 10) || 0;
    if (next < 0) next = 0;

    clearTimeout(input._deb);
    input._deb = setTimeout(function () {
      changeQuantityByKey(key, next);
    }, 250);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && isOpen()) {
      toggleDrawer(false);
    }
  }

  // ------- Init -------

  function init() {
    document.addEventListener('click', onClick);
    document.addEventListener('input', onInputChange);
    document.addEventListener('keydown', onKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Globalt API som drye-atc.js använder
  window.DRYE_CartDrawer = {
    open: function () { toggleDrawer(true); },
    close: function () { toggleDrawer(false); },
    refresh: refreshCartSection
  };
})();
